import { AssistantChatHub } from "../components/assistant-chat";

const AssistantChatPage = () => {
  return <AssistantChatHub />;
};
export default AssistantChatPage;
